export const HORIZONTAL_PADDING = 16;
